import { render, staticRenderFns } from "./FacebookSocialIcon.vue?vue&type=template&id=39c82ac6&"
import script from "./FacebookSocialIcon.vue?vue&type=script&lang=ts&"
export * from "./FacebookSocialIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports